import type { JSX } from 'react';

import { cn } from '@/lib/utils';

interface SignalBarsProps {
  /** 1..3 lit bars (3 = best). */
  readonly level: 1 | 2 | 3;
  readonly className?: string;
}

/**
 * Connection-quality bars from the Syncra mockup's shared atoms: three ascending pin bars,
 * the first `level` of them lit emerald. Decorative (aria-hidden); the meaningful value is
 * rendered as text next to it.
 */
export function SignalBars({ level, className }: SignalBarsProps): JSX.Element {
  const bars = [4, 7, 10];
  return (
    <span aria-hidden className={cn('inline-flex items-end gap-[2px]', className)}>
      {bars.map((height, index) => (
        <span
          key={height}
          style={{ height }}
          className={cn('w-[3px] rounded-[1px]', index < level ? 'bg-emerald-400' : 'bg-zinc-600')}
        />
      ))}
    </span>
  );
}
